module.exports = __webpack_public_path__ + "static/media/SWAMP.25531089.svg";